import { BASE_FONT_SIZE } from './constants';


const pxToRem = (size: number) => `${(size / BASE_FONT_SIZE) * 1}rem`;

const getMeasureProp = (v: string | number) => typeof v === 'string' ? v : v + 'px';

function makeStandartMargins(marginName: string) {
	const map = {
		'bottom-none': 'margin-bottom: 0',
		'bottom-small': 'margin-bottom: 16px',
		'bottom-medium': 'margin-bottom: 24px'
	};

	return map[marginName] || '';
}

function convertColorToString(color) {
  var type = color.type,
      values = color.values;

  if (type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

function makeBoxShadows(elevation: number) {
	const map = {
		'1': `box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.08);`,
		'2': `box-shadow: 0 1px 6px rgba(0, 0, 0, 0.09), 0 1px 4px rgba(0, 0, 0, 0.09);`,
		'3': `box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.1);`,
		'4': `box-shadow: 0 1px 10px rgba(0, 0, 0, 0.11), 0 1px 8px rgba(0, 0, 0, 0.11);`,
		'5': `box-shadow: 0 1px 12px rgba(0, 0, 0, 0.12), 0 1px 10px rgba(0, 0, 0, 0.12);`,
		'6': `box-shadow: 0 1px 14px rgba(0, 0, 0, 0.13), 0 1px 12px rgba(0, 0, 0, 0.13);`,
		'7': `box-shadow: 0 1px 16px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.14);`,
		'8': `box-shadow: 0 1px 18px rgba(0, 0, 0, 0.15), 0 1px 16px rgba(0, 0, 0, 0.15);`,
		'9': `box-shadow: 0 1px 20px rgba(0, 0, 0, 0.16), 0 1px 18px rgba(0, 0, 0, 0.16);`,
		'10': `box-shadow: 0 1px 22px rgba(0, 0, 0, 0.18), 0 1px 20px rgba(0, 0, 0, 0.18);`,
	}

	return map[elevation] || '';
}

const convertRGBtoRGBA = (color: string, alfa: number): string => {
	const rgba = `rgba(${color.split('(')[1].split(')')[0]}, ${alfa})`;

	return rgba;
}

const textClip = () => {
	return `
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	`;
};

function getInfinityColor(palette: Array<string>, idx: number) {
	const immPalette = [...palette];
	let color = immPalette[idx];

	while(!color) {
		if (!immPalette[idx]) {
			immPalette.push(...palette);
		}

		color = immPalette[idx];
	}

	return color;
}

export {
	pxToRem,
	getMeasureProp,
	makeStandartMargins,
	convertHexToRGB,
	lighten,
	darken,
	makeBoxShadows,
	convertRGBtoRGBA,
	textClip,
	getInfinityColor,
};
